import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from 'sonner';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AuditLog } from './pages/Audit';
import { Dashboard } from './pages/Dashboard';
import { AppealReview, AppealsList } from './pages/Appeals/Review';
import { DenialDetail } from './pages/Denials/Detail';
import { DenialsList } from './pages/Denials/List';
import { Settings } from './pages/Settings';
import { LoginPage } from './pages/auth/LoginPage';
import { SignUpPage } from './pages/auth/SignUpPage';

export function App() {
  return (
    <BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignUpPage />} />

        {/* Protected routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<Layout />}>
            <Route index element={<Navigate to="/denials" replace />} />
            <Route
              path="/denials"
              element={
                <ErrorBoundary>
                  <DenialsList />
                </ErrorBoundary>
              }
            />
            <Route
              path="/denials/:id"
              element={
                <ErrorBoundary>
                  <DenialDetail />
                </ErrorBoundary>
              }
            />
            <Route
              path="/appeals"
              element={
                <ErrorBoundary>
                  <AppealsList />
                </ErrorBoundary>
              }
            />
            <Route
              path="/appeals/:id"
              element={
                <ErrorBoundary>
                  <AppealReview />
                </ErrorBoundary>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ErrorBoundary>
                  <Dashboard />
                </ErrorBoundary>
              }
            />

            {/* Admin-only routes */}
            <Route element={<ProtectedRoute requiredRole="admin" />}>
              <Route
                path="/settings"
                element={
                  <ErrorBoundary>
                    <Settings />
                  </ErrorBoundary>
                }
              />
              <Route
                path="/audit"
                element={
                  <ErrorBoundary>
                    <AuditLog />
                  </ErrorBoundary>
                }
              />
            </Route>

            <Route path="*" element={<Navigate to="/denials" replace />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
